module.exports = __webpack_public_path__ + "img/logo.c6d33ecb.png";